import { useState, useEffect } from 'react';
import { Card, Form, Input, Button, message, Spin } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { adminAPI } from '../services/api';

const MiniProgramConfig = () => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => { fetchConfig(); }, []);

  const fetchConfig = async () => {
    setLoading(true);
    try {
      const res = await adminAPI.getConfigs();
      if (res.code === 0) {
        const list = res.data?.list || [];
        const home = list.find(c => c.config_key === 'mp_home_url');
        const about = list.find(c => c.config_key === 'mp_about_url');
        form.setFieldsValue({
          mp_home_url: home?.config_value || '',
          mp_about_url: about?.config_value || '',
        });
      }
    } catch (e) { message.error('获取配置失败'); }
    finally { setLoading(false); }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      const values = await form.validateFields();
      await adminAPI.updateConfigByKey('mp_home_url', values.mp_home_url || '');
      await adminAPI.updateConfigByKey('mp_about_url', values.mp_about_url || '');
      message.success('保存成功');
    } catch (e) { message.error('保存失败'); }
    finally { setSaving(false); }
  };

  return (
    <div className="admin-page-wrapper">
      <div className="admin-page-container">
        <div className="page-header">
          <h2>小程序配置</h2>
          <p>配置小程序首页和关于我们的外部链接地址</p>
        </div>
        <Spin spinning={loading}>
          <Form form={form} layout="vertical">
            <Card title="页面链接配置" style={{ marginBottom: 16 }}>
              <Form.Item name="mp_home_url" label="首页链接" extra="小程序首页通过 WebView 加载此链接">
                <Input placeholder="https://www.zjlinghu.com" />
              </Form.Item>
              <Form.Item name="mp_about_url" label="关于我们链接" extra="小程序关于我们页面通过 WebView 加载此链接">
                <Input placeholder="https://www.zjlinghu.com/about" />
              </Form.Item>
            </Card>
            <Button type="primary" icon={<SaveOutlined />} onClick={handleSave} loading={saving} size="large">
              保存配置
            </Button>
          </Form>
        </Spin>
      </div>
    </div>
  );
};

export default MiniProgramConfig;
